package com.eladfinish.bible.contest.network.spreadsheet

import com.eladfinish.bible.contest.network.DefaultApiResult
import com.eladfinish.bible.contest.network.apiTextResult
import com.eladfinish.bible.contest.platform.isWeb
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.request.parameter
import io.ktor.client.request.url
import io.ktor.util.date.getTimeMillis

interface SpreadsheetApi {
    suspend fun getDataFromSpreadsheet(
        spreadsheetId: String,
        sheetId: String = "",
        refreshData: Boolean = true,
    ): DefaultApiResult<String>
}

class SpreadsheetApiImpl(
    private val client: HttpClient,
) : SpreadsheetApi {

    //google sheet API v4
//    @GET("https://docs.google.com/spreadsheets/d/{id}/gviz/tq?tqx=out:json&gid={sheet_id}")
//    @GET("https://docs.google.com/spreadsheets/d/{id}/gviz/tq?tqx=out:json")
    /**
    without header "X-DataSource-Auth: true", response starts with:
    /*O_o*/
    google.visualization.Query.setResponse({"version":"0.6",

    with header "X-DataSource-Auth: true", response starts with:
    )]}'
    {"version":"0.6",
     */
    override suspend fun getDataFromSpreadsheet(
        spreadsheetId: String,
        sheetId: String,
        refreshData: Boolean,
    ): DefaultApiResult<String> =
        apiTextResult {
            client.get {
                url(gvizUrl(spreadsheetId = spreadsheetId, sheetId = sheetId))
                // On web, this custom header forces a CORS preflight that Google's endpoint
                // doesn't allow it through (it only allows a plain GET cross-origin), so every
                // spreadsheet-backed screen (PairMatching, OpenQuestions, Monopoly, ...) would
                // fail with "Failed to fetch" — see toGoogleSheetTableRawJson() for the resulting
                // response-format difference this header controls.
                if (!isWeb) {
                    header("X-DataSource-Auth", true)
                }
                if (refreshData) {
                    parameter("refreshData", getTimeMillis())
                }
                println("Spreadsheet_url ${this.url}")
            }
        }

}
